import React from 'react';
import { Check } from 'lucide-react';
import childrenImage from '../assets/Fotografija_4-min.jpg';

const BecomeAFranchisee = ({toSection,section}) => {

  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const benefits = [
    "You'll make a difference in your local community",
    "You'll build your business from scratch, but with all the support and training the franchise offers",
    "You'll make a change in the way children learn",
    "You'll join a growing market"
  ];

  return (
    <div  id={section} style={{marginTop:'-140px'}} className="relative bg-[#E6F4FF] py-40">
      {/* Top wave */}
      <div  className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 120" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '60px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="white" 
            d="M0,32L60,37.3C120,43,240,53,360,58.7C480,64,600,64,720,58.7C840,53,960,43,1080,42.7C1200,43,1320,53,1380,58.7L1440,64L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z"
          />
        </svg>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4">
        <div  className="grid md:grid-cols-2 gap-12 ">
          {/* Image side */}
          <div className="bg-white rounded-2xl shadow-xl">
            <img 
              src={childrenImage}
              style={{ maxHeight: '500px' }}
              alt="Children at Tinker Labs" 
              className="w-auto h-full object-cover  rounded-2xl shadow-xl"
            />
          </div>

          {/* Text content */}
          <div className='bg-white rounded-2xl shadow-xl p-10'>
            <h2 className="font-['Grandstander'] text-[#002147] text-4xl font-extrabold mb-8">
              Become a Tinker Labs Franchisee and See for Yourself:
            </h2>
            
            <div className="space-y-4 font-['Lexend']">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <Check className="w-6 h-6 text-[#0088CE] flex-shrink-0 mt-1" />
                  <p className="text-gray-700 text-lg">{benefit}</p>
                </div>
              ))}
            </div>

            <button onClick={()=>toSection('next',section)} className="bg-[#F18917] text-white px-8 py-3 rounded-full font-['Lexend'] font-semibold hover:bg-[#FF5A1F] transition-all mt-8">
              LEARN MORE
            </button>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 120" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '60px' }}
        >
          <path 
            fill="white" 
            d="M0,32L60,37.3C120,43,240,53,360,58.7C480,64,600,64,720,58.7C840,53,960,43,1080,42.7C1200,43,1320,53,1380,58.7L1440,64L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default BecomeAFranchisee;